import script from "./importData.vue?vue&type=script&setup=true&lang=js"
export * from "./importData.vue?vue&type=script&setup=true&lang=js"

import "./importData.vue?vue&type=style&index=0&id=25194336&lang=scss"

const __exports__ = script;

export default __exports__